// @flow

import React from 'react';
import { Helmet } from 'react-helmet';
import type { Node } from 'react';

import UI from 'components/Global/UI';
import Vendor from 'components/Global/Vendor';
import { ModalContextProvider, NavContextProvider, PageContextProvider } from 'contexts';

type SiteContainerProps = {
  children: Node,
  location: Location,
};

const SiteContainer = ({ children, ...rest }: SiteContainerProps) => (
  <NavContextProvider>
    <ModalContextProvider>
      <PageContextProvider>
        <Helmet>
          <html lang="en" />
        </Helmet>
        <Vendor />
        <UI {...rest}>{children}</UI>
      </PageContextProvider>
    </ModalContextProvider>
  </NavContextProvider>
);

export default SiteContainer;
